export let COLOR_PALETTE = null;

export let ICON_COLOR = '';

export let REDIRECT_URL = '';
export let categoryProduct = '';
export let productPageName = '';

export let GOOGLE_MAPS_API_KEY = '';

export let GOOGLE_MAPS_CLIENT_ID = 'gme-axaitalia';

// COLORS TEST CASES

// COLOR_PALETTE = {
// 	'--axa-locator-primary': '#000090',
// 	'--axa-locator-primary-alt': '#2c2ec2',
// 	'--axa-locator-secondary': '#f07762',
// 	'--axa-locator-highlight': '#eaf1fa',
// 	'--axa-locator-tertiary': 'grey',
// 	'--axa-locator-bg': 'white',
// 	'--axa-locator-border': '#d2d2d2',
// 	'--axa-locator-tab-bg': '#d3e3f5',
// 	'--axa-locator-text': '#333',
// 	'--axa-locator-text-secondary': 'white',
// 	'--axa-locator-modal-bg': 'rgba(0, 0, 144, 0.4)',
// 	'--axa-locator-modal-body': '#f4f4f4'
// };

// COLOR_PALETTE = {
// 	'--axa-locator-primary': '#fc9403',
// 	'--axa-locator-primary-alt': '#fcb503',
// 	'--axa-locator-secondary': '#eb03fc',
// 	'--axa-locator-highlight': '#fcdb03',
// 	'--axa-locator-tertiary': 'grey',
// 	'--axa-locator-bg': 'white',
// 	'--axa-locator-border': '#d2d2d2',
// 	'--axa-locator-tab-bg': '#fcf003',
// 	'--axa-locator-text': '#333',
// 	'--axa-locator-text-secondary': 'white',
// 	'--axa-locator-modal-bg': 'rgba(0, 0, 144, 0.4)',
// 	'--axa-locator-modal-body': '#f4f4f4'
// };

export function setFromPortletConfiguration(config) {
	if (config) {
		if (config.COLOR_PALETTE) {
			COLOR_PALETTE = config.COLOR_PALETTE;

			// Making the modal overlay semi-transparent...
			if (COLOR_PALETTE['--axa-locator-modal-bg'])
				COLOR_PALETTE['--axa-locator-modal-bg'] =
					COLOR_PALETTE['--axa-locator-modal-bg'] + '66';
		}

		if (config.ICON_COLOR) {
			ICON_COLOR = config.ICON_COLOR;
		}

		if (config.REDIRECT_URL) {
			REDIRECT_URL = config.REDIRECT_URL;
		}

		if (config.categoryProduct) {
			categoryProduct = config.categoryProduct;
		}

		if (config.productPageName) {
			productPageName = config.productPageName;
		}

		if (config.GOOGLE_MAPS_API_KEY) {
			GOOGLE_MAPS_API_KEY = config.GOOGLE_MAPS_API_KEY;
		}

		if (config.GOOGLE_MAPS_CLIENT_ID) {
			GOOGLE_MAPS_CLIENT_ID = config.GOOGLE_MAPS_CLIENT_ID;
		}
	}

	console.log('[CTA Google Maps] API Key: ' + (GOOGLE_MAPS_API_KEY ? 'configured' : 'NOT configured') + ', Client ID: ' + (GOOGLE_MAPS_CLIENT_ID ? 'configured' : 'NOT configured'));
}
